import { FormattedMessage } from 'react-intl'
import FormatCurrency from 'components/Common/FormatCurrency/FormatCurrency'
import PriceRowCaption from 'LuxKit/PricePoints/PriceRowCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import type { PackageOptionUpgradeView } from './PackageUpgradeModal.types'
import getPackageUpgradePrice from './getPackageUpgradePrice'
import PackageUpgradePriceStack from './PackageUpgradePriceStack'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCharterBundleRoute } from 'selectors/offerPage/initialOfferPageStateSelectors'

interface Props {
  packageUpgrade: PackageOptionUpgradeView
  hasFlightsSelected?: boolean
}

function LePackageUpgradePrice({
  packageUpgrade,
  hasFlightsSelected,
}: Props) {
  const charterBundleRoute = useAppSelector(state => getCharterBundleRoute(state, packageUpgrade.offer))
  const { total, isSamePrice, price, memberPrice, duration } = getPackageUpgradePrice(packageUpgrade, hasFlightsSelected, charterBundleRoute)

  return <div>
    {isSamePrice && <PriceRowPrice
      size="M"
      price={price}
      signDisplay="always"
      saleUnit=""
    />}
    {!isSamePrice &&
      <PackageUpgradePriceStack
        price={price}
        memberPrice={memberPrice}
        offerConfig={packageUpgrade.offer.luxPlus}
      />}
    <PriceRowCaption>
      <FormattedMessage
        id="8ONE-zcJQR6FuYdBVV-k"
        defaultMessage="{totalPrice} total for {duration, plural, one {# night} other {# nights}}"
        description="Price caption showing total cost and number of nights in package upgrade"
        values={{
          totalPrice: <FormatCurrency value={total} />,
          duration,
        }}
      />
    </PriceRowCaption>
  </div>
}

export default LePackageUpgradePrice
